import { render, staticRenderFns } from "./UpdatePermissionsModal.vue?vue&type=template&id=024fc9e2&scoped=true&"
import script from "./UpdatePermissionsModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePermissionsModal.vue?vue&type=style&index=0&id=024fc9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024fc9e2",
  null
  
)

export default component.exports